"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPIRE_WAITLIST_RESPONSE_EXAMPLE = exports.PROMOTE_WAITLIST_RESPONSE_EXAMPLE = exports.APPOINTMENT_WAITLIST_RESPONSE_EXAMPLE = void 0;
/**
 * Response DTOs for the 3 Waitlist endpoints. `AppointmentWaitlistDto`
 * is declared once here (not reused elsewhere, unlike `AppointmentDto`)
 * since no other category returns a waitlist row.
 */
const appointment_common_response_1 = require("./appointment-common.response");
exports.APPOINTMENT_WAITLIST_RESPONSE_EXAMPLE = {
    id: '50000000-0000-0000-0000-000000000001',
    tenantId: '11111111-1111-1111-1111-111111111111',
    branchId: '33333333-3333-3333-3333-333333333333',
    departmentId: '44444444-4444-4444-4444-444444444444',
    doctorId: '22222222-2222-2222-2222-222222222222',
    patientId: '11111111-1111-1111-1111-111111111111',
    desiredFromDate: '2026-08-01',
    desiredToDate: '2026-08-07',
    priorityTier: 0,
    status: 'WAITING',
    offeredSlotAt: null,
    offerExpiresAt: null,
    createdAt: '2026-07-11T09:00:00.000Z',
    updatedAt: '2026-07-11T09:00:00.000Z',
};
exports.PROMOTE_WAITLIST_RESPONSE_EXAMPLE = {
    offer: { ...exports.APPOINTMENT_WAITLIST_RESPONSE_EXAMPLE, status: 'OFFERED', offeredSlotAt: '2026-08-01T10:00:00.000Z' },
    appointment: appointment_common_response_1.APPOINTMENT_RESPONSE_EXAMPLE,
};
exports.EXPIRE_WAITLIST_RESPONSE_EXAMPLE = [
    { ...exports.APPOINTMENT_WAITLIST_RESPONSE_EXAMPLE, status: 'EXPIRED' },
];
//# sourceMappingURL=waitlist.response.js.map